import { render, staticRenderFns } from "./LearningGoalsForBlockButton.vue?vue&type=template&id=0060763e&"
import script from "./LearningGoalsForBlockButton.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsForBlockButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports